import Vue from 'vue';

import { apiPath } from '@/api/constants';

export default Vue.resource(
  `${apiPath}/apps/{package}/transaction-list-report/`,
  {},
  {
    sendTransactionFileToEmail: {
      method: 'POST',
    },
  },
);
